import { VisibilityOutlined } from "@material-ui/icons";
import { PrimaryIconButton } from "components";

const PrimaryViewButton = ({ onClick, tooltipTitle, disabled, loading, ...rest }) => {
  return (
    <PrimaryIconButton
      icon={<VisibilityOutlined />}
      onClick={onClick}
      tooltipTitle={tooltipTitle}
      disabled={disabled}
      loading={loading}
      {...rest}
    />
  );
};

export default PrimaryViewButton;
